module.exports = __webpack_public_path__ + "static/media/md-medal.9a281aab.svg";